// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"125":"7b2bffe4","356":"77f5d742","382":"0377b91b","635":"23e24498","992":"b23dd589"}[chunkId] + ".chunk.css";
};